import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAP_TOKEN, ZOOM_MAP_BUILDING } from "../resources/Constants";
function CustomGoogleMap(props) {
    const { mapContainerStyle, coordinates } = props;
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: GOOGLE_MAP_TOKEN, // ,
        // ...otherOptions
    });

    const renderMap = () => {
        // wrapping to a function is useful in case you want to access `window.google`
        // to eg. setup options or create latLng object, it won't be available otherwise
        // feel free to render directly if you don't need that
        // const onLoad = React.useCallback(
        //   function onLoad (mapInstance) {
        //     // do something with map Instance
        //   }
        // )
        return (
            <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={coordinates}
                zoom={ZOOM_MAP_BUILDING}
                className="map-container"
            >
                <Marker position={coordinates} />
            </GoogleMap>
        );
    };

    if (loadError) {
        return <div>Map cannot be loaded right now, sorry.</div>;
    }

    return isLoaded && renderMap();
}

export default CustomGoogleMap;
